import trackingCodes from '~/tracking_codes/all.js';
import $ from 'jquery';

global.trackingCode = function (pageId) {
  var codes = '';
  if (typeof trackingCodes[pageId] !== 'undefined') {
    for (var i in trackingCodes[pageId]) {
      var websiteMatchPattern = trackingCodes[pageId][i].website ? trackingCodes[pageId][i].website.host_name_regexp : null;
      if (websiteMatchPattern) {
        var hostnameRegEx = new RegExp(websiteMatchPattern);
        if (hostnameRegEx.test(window.location.hostname)) {
          if (trackingCodes[pageId][i].status == 'active') {
            codes += "\n" + Buffer.from(trackingCodes[pageId][i].code, 'base64').toString('utf8');
            //codes += "\n" + trackingCodes[pageId][i].code;
          }
        }
      }
    }
  }

  return codes;
};

export default (function (_ref, inject) {
  var app = _ref.app,
      redirect = _ref.redirect;

  app.router.afterEach(function (to, from) {
    $('#trackingCodes').html(trackingCode('ALL_PAGES'));
    switch (to.name) {
      case 'lang-successful-signup':
        $('#trackingCodes').append(trackingCode('SUCCESSFUL_REGISTRATION_PAGE'));
        break;

      case 'lang-signup':
        $('#trackingCodes').append(trackingCode('REGISTRATION_PAGE'));
        break;

      case 'lang-search-results-type-search':
        $('#trackingCodes').append(trackingCode('RESULTS_PAGE'));
        break;

      case 'lang-search-results-type-search-loading':
        $('#trackingCodes').append(trackingCode('LOADING_PAGE'));
        break;

      case 'lang-download-app-successful-download-app':
        $('#trackingCodes').append(trackingCode('DOWNLOAD_APP_PAGE'));
        break;

      case 'lang-set-password':
        $('#trackingCodes').append(trackingCode('SET_PASSWORD_PAGE'));
        break;

    }
  });
});


//////////////////
// WEBPACK FOOTER
// ./plugins/tracking-code-lib.js
// module id = ./plugins/tracking-code-lib.js
// module chunks = 54